// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceField
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DataSourceField } from "abweb/dto/ds/DataSourceField";
import { DataSourceRecordFormat } from "abweb/dto/ds/DataSourceRecordFormat";
import { DataSourceValidation } from "abweb/dto/ds/DataSourceValidation";
import { DataFieldTypeEnum } from "abweb/dto/generated/ds/DataFieldTypeEnum";
import { RecordFieldTypeEnum } from "abweb/dto/generated/ds/RecordFieldTypeEnum";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class DataSourceFieldBase {
  /** Do NOT invoke directly, instead use strongly typed createDataSourceFieldBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.DataSourceField";
  }
  initFromJson(json, deserializeContext) {
    this.initDataSourceField(json.attributes != null ? json.attributes : null, json.defaultValue != null ? json.defaultValue : null, json.displayName != null ? json.displayName : null, json.editable != null ? json.editable : null, json.editableIfNullOnly != null ? json.editableIfNullOnly : null, json.fieldType != null ? DataFieldTypeEnum.fromJson(json.fieldType) : null, json.filterable != null ? json.filterable : null, json.hasDependentFields != null ? json.hasDependentFields : null, TSOGUtils.decodeObject(json.itemType, DataSourceField, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "itemType")), json.name != null ? json.name : null, json.populated != null ? json.populated : null, TSOGUtils.decodeObject(json.recordFormat, DataSourceRecordFormat, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "recordFormat")), json.refObject != null ? json.refObject : null, json.required != null ? json.required : null, json.sortable != null ? json.sortable : null, json.type != null ? RecordFieldTypeEnum.fromJson(json.type) : null, TSOGUtils.decodeObject(json.validation, DataSourceValidation, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "validation")));
  }
  initDataSourceField(attributes, defaultValue, displayName, editable, editableIfNullOnly, fieldType, filterable, hasDependentFields, itemType, name, populated, recordFormat, refObject, required, sortable, type, validation) {
    this._attributes = attributes;
    this._defaultValue = defaultValue;
    this._displayName = displayName;
    this._editable = editable;
    this._editableIfNullOnly = editableIfNullOnly;
    this._fieldType = fieldType;
    this._filterable = filterable;
    this._hasDependentFields = hasDependentFields;
    this._itemType = itemType;
    this._name = name;
    this._populated = populated;
    this._recordFormat = recordFormat;
    this._refObject = refObject;
    this._required = required;
    this._sortable = sortable;
    this._type = type;
    this._validation = validation;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    if (this._attributes != null) {
      retVal["attributes"] = this._attributes;
    }
    if (this._defaultValue != null) {
      retVal["defaultValue"] = this._defaultValue;
    }
    if (this._displayName != null) {
      retVal["displayName"] = this._displayName;
    }
    retVal["editable"] = this._editable;
    retVal["editableIfNullOnly"] = this._editableIfNullOnly;
    if (this._fieldType != null) {
      retVal["fieldType"] = this._fieldType;
    }
    retVal["filterable"] = this._filterable;
    retVal["hasDependentFields"] = this._hasDependentFields;
    if (this._itemType != null) {
      retVal["itemType"] = TSOGUtils.toTSOGNativeObject(this._itemType, serializeContext);
    }
    if (this._name != null) {
      retVal["name"] = this._name;
    }
    retVal["populated"] = this._populated;
    if (this._recordFormat != null) {
      retVal["recordFormat"] = TSOGUtils.toTSOGNativeObject(this._recordFormat, serializeContext);
    }
    if (this._refObject != null) {
      retVal["refObject"] = this._refObject;
    }
    retVal["required"] = this._required;
    retVal["sortable"] = this._sortable;
    retVal["type"] = this._type;
    if (this._validation != null) {
      retVal["validation"] = TSOGUtils.toTSOGNativeObject(this._validation, serializeContext);
    }
    return retVal;
  }
  get attributes() {
    return this._attributes;
  }
  set attributes(value) {
    this._attributes = value;
  }
  get defaultValue() {
    return this._defaultValue;
  }
  set defaultValue(value) {
    this._defaultValue = value;
  }
  get displayName() {
    return this._displayName;
  }
  set displayName(value) {
    this._displayName = value;
  }
  get editable() {
    return this._editable;
  }
  set editable(value) {
    this._editable = value;
  }
  get editableIfNullOnly() {
    return this._editableIfNullOnly;
  }
  set editableIfNullOnly(value) {
    this._editableIfNullOnly = value;
  }
  get fieldType() {
    return this._fieldType;
  }
  set fieldType(value) {
    this._fieldType = value;
  }
  get filterable() {
    return this._filterable;
  }
  set filterable(value) {
    this._filterable = value;
  }
  get hasDependentFields() {
    return this._hasDependentFields;
  }
  set hasDependentFields(value) {
    this._hasDependentFields = value;
  }
  get itemType() {
    return this._itemType;
  }
  set itemType(value) {
    this._itemType = value;
  }
  get name() {
    return this._name;
  }
  set name(value) {
    this._name = value;
  }
  get populated() {
    return this._populated;
  }
  set populated(value) {
    this._populated = value;
  }
  get recordFormat() {
    return this._recordFormat;
  }
  set recordFormat(value) {
    this._recordFormat = value;
  }
  get refObject() {
    return this._refObject;
  }
  set refObject(value) {
    this._refObject = value;
  }
  get required() {
    return this._required;
  }
  set required(value) {
    this._required = value;
  }
  get sortable() {
    return this._sortable;
  }
  set sortable(value) {
    this._sortable = value;
  }
  get type() {
    return this._type;
  }
  set type(value) {
    this._type = value;
  }
  get validation() {
    return this._validation;
  }
  set validation(value) {
    this._validation = value;
  }
}
//# sourceMappingURL=DataSourceFieldBase.js.map
